import React, { useState } from 'react';
import Seo, { breadcrumbSchema } from '@/components/Seo';
import Breadcrumbs from '@/components/Breadcrumbs';
import Reveal from '@/components/Reveal';
import CTAPanel from '@/components/CTAPanel';
import { GALLERY, GALLERY_CATS } from '@/data/siteData';

const Gallery = () => {
  const [cat, setCat] = useState('All');
  const items = cat === 'All' ? GALLERY : GALLERY.filter((g) => g.cat === cat);

  return (
    <>
      <Seo
        title="Provident Palm Vista Gallery | Photos & Master Plan"
        description="Provident Palm Vista gallery — master plan, tropical landscape, amenities, lifestyle and location images from the 16-acre Shilphata development."
        path="/gallery"
        jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Gallery', path: '/gallery' }])]}
      />
      <section className="pt-28 md:pt-36 pb-16 md:pb-24 bg-ivory min-h-[70vh]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Breadcrumbs items={[{ name: 'Gallery' }]} />
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-gold">Gallery</p>
            <h1 className="font-display text-4xl sm:text-5xl font-medium text-palm mt-3 leading-[1.08] tracking-tight">Provident Palm Vista Gallery</h1>
            <p className="text-[15px] text-ink/75 mt-5 max-w-3xl leading-relaxed">
              A visual tour of the development — the master plan, the tropical landscape concept, amenity spaces and the location. Images may be artistic or illustrative representations.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="flex flex-wrap gap-2 mt-8" data-testid="gallery-filters">
            {GALLERY_CATS.map((c) => (
              <button key={c} type="button" onClick={() => setCat(c)}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s/g, '-')}`}
                className={`rounded-full px-4 py-2 text-xs font-semibold transition-all ${
                  cat === c ? 'bg-palm text-ivory shadow' : 'bg-white border border-line text-palm hover:border-gold'
                }`}>
                {c}
              </button>
            ))}
          </Reveal>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 mt-8 space-y-4" data-testid="gallery-grid">
            {items.map((g) => (
              <Reveal key={g.src + g.cat} className="break-inside-avoid">
                <figure className="rounded-2xl overflow-hidden border border-line bg-white shadow-sm">
                  <img src={g.src} alt={g.alt} loading="lazy" width={g.w} height={g.h} className="w-full object-cover hover:scale-[1.02] transition-transform duration-500" />
                  <figcaption className="px-4 py-3 text-xs text-muted-foreground">{g.alt}</figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTAPanel title="See It in Person — Book a Site Visit" />
    </>
  );
};

export default Gallery;
